/**
 * DisableWorkshopRow — the danger-zone row that stops new sales on an active
 * workshop, after an inline confirm, so payments already in progress can finish
 * before it is cancelled.
 */
import { useState } from 'react';

import { DANGER_RED, DangerZoneRow } from '../../primitives';
import type { WorkshopSales } from '../use-workshop-sales';

export function DisableWorkshopRow({ sales }: { sales: WorkshopSales }) {
  const [confirming, setConfirming] = useState(false);
  const error = sales.errorMessage ? <span role="alert">{sales.errorMessage}</span> : null;

  if (!confirming) {
    return (
      <DangerZoneRow
        title="Disable workshop"
        warn={Boolean(error)}
        note={
          error ??
          'Stops new bookings so payments already in progress can finish. You can re-enable it later.'
        }
      >
        <button
          type="button"
          className="nb-btn"
          onClick={() => setConfirming(true)}
          style={{ color: DANGER_RED, borderColor: 'rgba(192,57,43,.4)', whiteSpace: 'nowrap' }}
        >
          Disable workshop
        </button>
      </DangerZoneRow>
    );
  }

  const confirm = async () => {
    if (await sales.run('disable')) setConfirming(false);
  };

  return (
    <DangerZoneRow
      title="Disable workshop"
      warn
      note={error ?? 'Customers won’t be able to book this workshop until you re-enable it.'}
    >
      <button
        type="button"
        className="nb-btn nb-btn-ghost"
        disabled={sales.isPending}
        onClick={() => setConfirming(false)}
      >
        Keep selling
      </button>
      <button
        type="button"
        className="nb-btn"
        disabled={sales.isPending}
        onClick={() => void confirm()}
        style={{
          color: '#fff',
          background: DANGER_RED,
          borderColor: DANGER_RED,
          whiteSpace: 'nowrap',
        }}
      >
        {sales.isPending ? 'Disabling…' : 'Confirm disable'}
      </button>
    </DangerZoneRow>
  );
}
